export default {
  BusinessReportSaleGoods: {
    orderTime: 'Order time',
    itemCodeName: 'Product name/code/code',
    channel: 'Channel',
    orderCount: 'Order count',
    balanceOrderCount: 'Daily order count',
    saleCount: 'Sales volume',
    balanceSaleCount: 'Daily sales volume',
    saleAmount: 'Sales amount',
    balanceSaleAmount: 'Daily sales amount',
    reverseItemCount: 'Quantity of returns',
    reverseAmount: 'Return amount'
  }
};
